/**
 * @Description 可编辑的开店区域详情内容
 * 附件&备注
 */

import { FC } from 'react';
import { isArray } from '@lhb/func';
// import cs from 'classnames';
// import styles from './entry.module.less';
import V2Title from '@/common/components/Feedback/V2Title';
import V2DetailItem from '@/common/components/Feedback/V2DetailItem';

interface EditableInfoProps {
  [p: string]: any;
}
const EditableInfo: FC<EditableInfoProps> = ({ detail }) => {
  const { remark, attachment } = detail || {};
  return (remark || (isArray(attachment) && attachment.length) ? <div>
    <div>
      <V2Title divider type='H2'>
        <span className='bold'>备注</span>
      </V2Title>
    </div>
    {remark ? <div
      className='mt-8'
      style={{
        width: '100%',
        overflow: 'hidden',
      }}
    >
      <div
        style={{
          whiteSpace: 'pre-wrap',
          wordWrap: 'break-word',
        }}
      >
        {remark}
      </div>
    </div> : <></>}
    {isArray(attachment) && attachment.length
      ? <V2DetailItem className='mt-8' label='' type='files' assets={attachment} />
      : <></>}
  </div> : <></>
  );
};

export default EditableInfo;
